export const languagesSupported = [
  {
    language: 'Spanish',
    shortCode: 'SPA',
    key: 'es',
  },
]
